"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

export default function NavigationProgress() {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const [ isNavigating, setIsNavigating ] = useState( false );
    const [ progress, setProgress ] = useState( 0 );

    useEffect( () => {
        // 开始导航
        setIsNavigating( true );
        setProgress( 0 );

        // 模拟进度条动画
        const timer1 = setTimeout( () => setProgress( 30 ), 100 );
        const timer2 = setTimeout( () => setProgress( 60 ), 300 );
        const timer3 = setTimeout( () => setProgress( 80 ), 500 );

        // 完成导航
        const completeTimer = setTimeout( () => {
            setProgress( 100 );
            // 延迟隐藏进度条，让用户看到完成动画
            setTimeout( () => {
                setIsNavigating( false );
                setProgress( 0 );
            }, 300 );
        }, 700 );

        return () => {
            clearTimeout( timer1 );
            clearTimeout( timer2 );
            clearTimeout( timer3 );
            clearTimeout( completeTimer );
        };
    }, [ pathname, searchParams ] );

    if ( !isNavigating ) return null;

    return (
        <div
            className="fixed top-0 left-0 right-0 z-[9999] h-[3px] bg-action-primary transition-all duration-300 ease-out max-w-[500px] mx-auto"
            style={{ width: `${progress}%`, opacity: progress === 100 ? 0 : 1 }}
        >
            {/* 发光效果 */}
            <div className="absolute right-0 top-0 h-full w-[100px] bg-gradient-to-l from-action-primary to-transparent opacity-50" />
        </div>
    );
}
